import request from "./api_client";

const updateDataUrl = {
  // Organisation - Create
  organisation_details: "/organisations",
  organisation_profile: "/organisation_profiles",
  organisation_contact: "/organisation_contact_infos",
  organisation_pre_contract: "/organisation_pre_contracts",
  organisation_general: "/organisation_general_details",
  organisation_contract: "/organisation_contract_phases",
  organisation_activity: "/organisation_activity_fields",
  organisation_business_developments: "/organisation_business_developments",
  // Employee - Update
  employee_contact_area: "/employees",
  employee_work_information: "/employee_work_infos",
  employee_coaching_capacity: "/employee_coaching_mentoring_capacities",
  employee_training_and_development: "/employee_training_developments",
  employee_mentoring_capacity: "/employee_coaching_mentoring_capacities",
  employee_coaching_profile: "/employee_coaching_mentoring_profiles",
  employee_facilitations: "/employee_facilitations",
  employee_assessments: "/employee_assessments",
  employee_gdprs: "/employee_gdprs",
  employee_file_upload: "/employees/file_upload",
  employee_backgrounds: "/employee_backgrounds",
  employee_coaching_backgrounds: "/employee_coaching_backgrounds",
  coaching_agreement_form_sections: "coaching_agreement_form_sections",
  //coaching rate cards
  coaching_rate_cards_update: "/rate_cards/update_available_region",

  //master template
  program_info: "/master_templates/update_program_info",
  update_commercial_billing: "master_templates/update_commercial_billing",
  update_master_template: "master_templates/update_master_template",

  // coaching dimensions
  coaching_dimensions: "master_templates/update_coaching_dimensions",

  //Organisation Metrics
  organisation_metrics: "/organisation_metrics",
  competencies: "/competencies",

  //Terms and policies
  terms_policies: "master_templates/update_terms_and_policies",
  terms_and_policies_fields: "terms_and_policies_fields",

  //Program flow setup
  program_flow_setup: "master_templates/update_pgm_flow_setup",

  //PROGRAM
  update_program_info: "programmes/update_program_info",
  update_coaching_dimensions: "programmes/update_coaching_dimensions",
  commercial_billing: "programmes/update_commercial_billing",
  update_terms_policies: "programmes/update_terms_and_policies",
  flow_setup: "programmes/update_pgm_flow_setup",
  update_program: "programmes/update_programme",
  update_external_coaching_rate: "rate_cards/update_external_rate_card",
  update_internal_coaching_rate: "rate_cards/update_internal_rate_card",

  //ASSIGNMENTS
  assignment_program_rate: "/assignments/update_program_info",
  assignment_coaching_dimensions: "assignments/update_coaching_dimensions",
  assignment_commercial_billing: "assignments/update_commercial_billing",
  assignment_pgm_flow_setup: "assignments/update_pgm_flow_setup",
  assignment_terms_policies: "assignments/update_terms_and_policies",

  // CAF
  coaching_agreement_form_fields: "coaching_agreement_form_fields",

  //SLA
  update_SLA: "slas/update_SLA",

  //Module
  update_module: "/module_setups/update_module",

  ///invoices/edit_po_number
  edit_po_number: "/invoices/edit_po_number",

  //EXTENSION
  update_extension: "/assignment_details/update_extension",

  //NOTIFICATION
  update_notification: "/notifications",

  //Feedback
  updateFeedback: "/feedbacks/update_feedback",

  //Acuty Feedback
  updateAcutyFeedback: "/acuity_feedbacks/update_feedback",
  // Program activity log toggle
  activityLogProgramToggle: "activity_logs/select_mini_mi_field",
  liveViewOrganisation: "organisations/update_live_organisation_data",
  liveViewPartner: "partner_profiles/update_live_partner_profile_data",
};

function updateData(formData, id = null, section, authHeaders) {
  return request({
    url: `${updateDataUrl[section]}/${id || ""}`,
    method: "PUT",
    data: formData,
    headers: authHeaders,
  });
}

export default updateData;
